// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"64c9ea33","167":"51779d6f"}[chunkId] + ".chunk.css";
};